import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningOutlineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 30,
	viewBox: "0 0 32 30",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.339 27 16 3.55 28.664 27zM18.2 1.313A2.5 2.5 0 0 0 16.001 0c-.919 0-1.762.506-2.2 1.313l-13.5 25c-.418.774-.4 1.712.05 2.468A2.5 2.5 0 0 0 2.501 30h27a2.51 2.51 0 0 0 2.15-1.219 2.49 2.49 0 0 0 .05-2.468zM16 10.5c-.831 0-1.5.669-1.5 1.5v7c0 .831.669 1.5 1.5 1.5s1.5-.669 1.5-1.5v-7c0-.831-.669-1.5-1.5-1.5M17.67 24a1.67 1.67 0 0 0-.8-1.531 1.69 1.69 0 0 0-1.731 0 1.67 1.67 0 0 0-.8 1.531 1.67 1.67 0 0 0 .8 1.531c.531.319 1.2.319 1.731 0 .531-.325.837-.912.8-1.531",
		fill: "currentColor"
	})
});
export default SvgWarningOutlineIcon;
